import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { visibleColumns as visibleTsunamiColumns, sort as tsunamiSort } from '../../event/data/tsunamiReduxConstants';
import { augmentDeposit } from '../depositReduxUtils';

export const CLEAR_DEPOSIT_RELATED_TSUNAMIS_DATA = 'CLEAR_DEPOSIT_RELATED_TSUNAMIS_DATA';

export const DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST = 'DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST';
export const DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_SUCCESS = 'DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_SUCCESS';
export const DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_FAILURE = 'DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_FAILURE';

export const DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SORT = 'DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SORT';
export const DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_TOGGLE_COLUMN = 'DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_TOGGLE_COLUMN';
export const DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST = 'DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST';
export const DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SUCCESS = 'DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SUCCESS';
export const DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_FAILURE = 'DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_FAILURE';
export const DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST = 'DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST';
export const DEPOSIT_RELATED_TSUNAMIS_DELETE_SUCCESS = 'DEPOSIT_RELATED_TSUNAMIS_DELETE_SUCCESS';
export const DEPOSIT_RELATED_TSUNAMIS_DELETE_FAILURE = 'DEPOSIT_RELATED_TSUNAMIS_DELETE_FAILURE';

export const DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST = 'DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST';
export const DEPOSIT_RELATED_TSUNAMIS_GEOAGE_SUCCESS = 'DEPOSIT_RELATED_TSUNAMIS_GEOAGE_SUCCESS';
export const DEPOSIT_RELATED_TSUNAMIS_GEOAGE_FAILURE = 'DEPOSIT_RELATED_TSUNAMIS_GEOAGE_FAILURE';

export const DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST = 'DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST';
export const DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_SUCCESS = 'DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_SUCCESS';
export const DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_FAILURE = 'DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_FAILURE';


const initialState = fromJS({

  fetchedDeposit: false,
  deposit: {},

  fetchedPublications: false,
  publications: [],
  fetchedGeologicAges: false,
  geologicAges: [],

  fetchedTsunamis: false,
  tsunamis: [],
  deletingTsunami: false,
  tsunamiSort,
  visibleTsunamiColumns,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const depositRelatedTsunamisReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_DEPOSIT_RELATED_TSUNAMIS_DATA:
      return initialState.merge(fromJS({
        tsunamiSort: state.get('tsunamiSort'),
        visibleTsunamiColumns: state.get('visibleTsunamiColumns'),
      }));


    case DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST:
      return state.merge(fromJS({
        fetchedDeposit: false,
      }));
    case DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_SUCCESS:
      return state.merge(fromJS({
        fetchedDeposit: true,
        deposit: augmentDeposit({
          deposit: fromJS(action.response),
          geologicAges: state.get('geologicAges'),
          publications: state.get('publications'),
        }),
      }));
    case DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_FAILURE:
      return state.merge(fromJS({
        fetchedDeposit: true,
      }));


    case DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamis: basicSort(action.sort, state.get('tsunamis')),
        tsunamiSort: action.sort,
      }));

    case DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleTsunamiColumns: action.visibleColumns,
      }));

    case DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunamis: false,
      }));
    case DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunamis: true,
        tsunamis: basicSort(state.get('tsunamiSort'), fromJS(action.response.items)),
      }));
    case DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunamis: true,
      }));

    case DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST:
      return state.set('deletingTsunami', true);
    case DEPOSIT_RELATED_TSUNAMIS_DELETE_SUCCESS:
    case DEPOSIT_RELATED_TSUNAMIS_DELETE_FAILURE:
      return state.set('deletingTsunami', false);

    case DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST:
      return state.merge(fromJS({
        fetchedGeologicAges: false,
      }));
    case DEPOSIT_RELATED_TSUNAMIS_GEOAGE_SUCCESS: {
      const geologicAges = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedGeologicAges: true,
        geologicAges,
        deposit: augmentDeposit({
          deposit: state.get('deposit'),
          geologicAges,
        }),
      }));
    }
    case DEPOSIT_RELATED_TSUNAMIS_GEOAGE_FAILURE:
      return state.merge(fromJS({
        fetchedGeologicAges: true,
      }));

    case DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST:
      return state.merge(fromJS({
        fetchedPublications: false,
      }));
    case DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_SUCCESS: {
      const publications = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedPublications: true,
        publications,
        deposit: augmentDeposit({
          deposit: state.get('deposit'),
          publications,
        }),
      }));
    }
    case DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_FAILURE:
      return state.merge(fromJS({
        fetchedPublications: true,
      }));


    default:
      return state;
  }
};
